import React from "react";
import { Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { DASHBOARD_SECONDARY, WHITE, IRIS_60 } from "../../colors";
import HeightBox from "../HeightBox";
import Skeleton from "@mui/material/Skeleton";

const CustomPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  paddingTop: 15,
  paddingBottom: 10,
  paddingLeft: 15,
  paddingRight: 15,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  borderRadius: 10,
  minWidth: 212,
}));

export default function UserDetailsCard(props) {
  const { title, amount, Icon, bgImage } = props;
  return (
    <CustomPaper
      sx={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
      }}
    >
      {props.title && (
        <>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography color={WHITE}>{title}</Typography>
            {/* {Icon} */}
          </Stack>

          <HeightBox height={10} />
          <Typography fontWeight={800} fontSize={21} color={WHITE}>
            {amount}
          </Typography>
        </>
      )}
      {!props.title && (
        <>
          <Skeleton variant="rectangular" width={180} height={100} />
        </>
      )}
    </CustomPaper>
  );
}
